"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contactPickerUtils = void 0;
function getInitials(data) {
  const {
    displayName,
    firstName,
    lastName,
    emailAddress,
    locale,
    displayNameHasBeenLocalized = false
  } = data;
  let initials = "";
  if (displayName) {
    const names = displayName.split(" ");
    const initialA = names[0].charAt(0);
    let initialB = "";
    if (names.length > 1) {
      initialB = names[names.length - 1].charAt(0);
    }
    initials = locale === "ja" && !displayNameHasBeenLocalized ? initialB + initialA : initialA + initialB;
  } else if (firstName && lastName) {
    const initialA = firstName.charAt(0);
    const initialB = lastName.charAt(0);
    initials = locale === "ja" ? initialB + initialA : initialA + initialB;
  } else if (firstName) {
    initials = firstName.charAt(0);
  } else if (lastName) {
    initials = lastName.charAt(0);
  } else {
    initials = emailAddress.charAt(0);
  }
  return initials.toUpperCase();
}
function dedupeContacts(contacts) {
  const uniqueIds = new Set();
  return contacts.filter(element => {
    const isDuplicate = uniqueIds.has(element.id);
    uniqueIds.add(element.id);
    return !isDuplicate;
  });
}
const contactPickerUtils = {
  getInitials,
  dedupeContacts
};
exports.contactPickerUtils = contactPickerUtils;
//# sourceMappingURL=contactPickerUtils.js.map